import React, { useEffect } from 'react';

// Inject global box-sizing style once
let globalStyleInjected = false;

const View = ({ style, children, ...props }) => {
  useEffect(() => {
    if (!globalStyleInjected) {
      const styleId = 'react-native-compat-global-styles';
      if (!document.getElementById(styleId)) {
        const styleElement = document.createElement('style');
        styleElement.id = styleId;
        styleElement.textContent = `
          * {
            box-sizing: border-box;
          }
        `;
        document.head.appendChild(styleElement);
        globalStyleInjected = true;
      }
    }
  }, []);
  // Convert React Native styles to CSS
  const convertStyle = (rnStyle) => {
    // Start with defaults
    const defaults = { display: 'flex', flexDirection: 'column' };
    
    if (!rnStyle) return defaults;
    
    const cssStyle = { ...defaults, ...rnStyle };
    
    // Handle flex shorthand
    if (typeof cssStyle.flex === 'number') {
      cssStyle.flexGrow = cssStyle.flex;
      cssStyle.flexShrink = 1;
      cssStyle.flexBasis = '0%';
      delete cssStyle.flex;
    }
    
    // Convert shadow properties
    if (cssStyle.shadowColor || cssStyle.shadowOffset || cssStyle.shadowOpacity || cssStyle.shadowRadius) {
      const shadowColor = cssStyle.shadowColor || '#000';
      const shadowOffset = cssStyle.shadowOffset || { width: 0, height: 0 };
      const shadowOpacity = cssStyle.shadowOpacity || 0;
      const shadowRadius = cssStyle.shadowRadius || 0;
      
      cssStyle.boxShadow = `${shadowOffset.width}px ${shadowOffset.height}px ${shadowRadius}px rgba(0,0,0,${shadowOpacity})`;
      
      delete cssStyle.shadowColor;
      delete cssStyle.shadowOffset;
      delete cssStyle.shadowOpacity;
      delete cssStyle.shadowRadius;
    }
    
    return cssStyle;
  };
  
  // Merge array styles first, then convert
  const mergedStyle = Array.isArray(style) 
    ? style.reduce((acc, s) => ({ ...acc, ...s }), {})
    : style;
    
  const processedStyle = convertStyle(mergedStyle);
    
  return (
    <div style={processedStyle} {...props}>
      {children}
    </div>
  );
};

export default View;